import { getPurchaseLineKey } from "./purchaseReceiving";

export const PURCHASE_DRAFT_STORAGE_KEY = "zaw-khin:purchase-receiving-draft:v1";
const PURCHASE_DRAFT_VERSION = 1;
const MAX_DRAFT_LINES = 500;

const cloneLines = (lines) => JSON.parse(JSON.stringify(lines));

export function createPurchaseDraftSnapshot({
  supplierId = "",
  submissionKey,
  lines = [],
  updatedAt = new Date().toISOString(),
}) {
  return {
    version: PURCHASE_DRAFT_VERSION,
    supplierId: supplierId === null || supplierId === undefined
      ? ""
      : String(supplierId),
    submissionKey: String(submissionKey || ""),
    lines: cloneLines(Array.isArray(lines) ? lines : []),
    updatedAt: String(updatedAt),
  };
}

export function parsePurchaseDraftSnapshot(value) {
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    if (!parsed || typeof parsed !== "object") return null;
    if (parsed.version !== PURCHASE_DRAFT_VERSION) return null;
    if (!String(parsed.submissionKey || "").trim()) return null;
    if (!Array.isArray(parsed.lines) || parsed.lines.length > MAX_DRAFT_LINES) {
      return null;
    }
    if (!Number.isFinite(Date.parse(parsed.updatedAt))) return null;
    return createPurchaseDraftSnapshot(parsed);
  } catch {
    return null;
  }
}

export function chooseLatestPurchaseDraft(localDraft, remoteDraft) {
  const local = parsePurchaseDraftSnapshot(localDraft);
  const remote = parsePurchaseDraftSnapshot(remoteDraft);
  if (!local) return remote;
  if (!remote) return local;
  return Date.parse(remote.updatedAt) > Date.parse(local.updatedAt)
    ? remote
    : local;
}

export function reconcilePurchaseDraft({
  draft,
  inventory = [],
  activeSuppliers = [],
}) {
  const lineErrors = {};
  const supplierId = String(draft?.supplierId || "");
  const supplierIsActive = !supplierId || activeSuppliers.some(
    (supplier) => supplier.active !== false && String(supplier.id) === supplierId,
  );
  const inventoryById = new Map(
    (inventory || []).map((item) => [String(item.id), item]),
  );

  for (const line of draft?.lines || []) {
    if (line.isNewItem) continue;
    const key = getPurchaseLineKey(line);
    const item = inventoryById.get(String(line.itemId));
    if (!item) {
      lineErrors[key] = `${line.itemName || "This product"} no longer exists in inventory.`;
      continue;
    }

    if (line.productUnitId !== null && line.productUnitId !== undefined) {
      const unit = (item.product_units || []).find(
        (candidate) => Number(candidate.id) === Number(line.productUnitId),
      );
      if (!unit || unit.is_active === false) {
        lineErrors[key] = `${line.unitName || "This unit"} is no longer an active packaging unit for ${line.itemName || item.name}.`;
      }
    } else if (item.unit_inventory_enabled) {
      lineErrors[key] = `Select an active packaging unit for ${line.itemName || item.name}.`;
    }
  }

  return {
    supplierError: supplierIsActive
      ? ""
      : "The selected supplier is no longer active. Choose another supplier.",
    lineErrors,
  };
}
